import type { CareDefinitions } from '@/types/care'

/**
 * The questionnaire definition behind a care module: what each calculator is called, what colour
 * its section draws in, what it is scored out of, and what every question and option is named.
 *
 * **Nothing serves this to PA yet.** The trend read deliberately stores hashes only —
 *
 * > "Question titles, option labels and calculator names are **not** stored by this service.
 * >  Resolve them from the questionnaire definition in e-pharmacy-api."
 *
 * — and `/prescriber/questionnaires` returns module metadata (title, count, tags, templates)
 * without questions or sections. So this is the seam: when an endpoint exists that returns a
 * module's sections and questions, it is fetched here and mapped to `CareDefinitions`, and nothing
 * downstream changes.
 *
 * Until then it resolves to null, which is why the card renders its "not available yet" state
 * rather than an empty chart. Sample definitions are not returned from here: they only describe the
 * sample check-ins, so the panel pairs the two itself and never lends fixture labels to real data.
 */
export const useCareDefinitions = (questionnaireHash: string | undefined): CareDefinitions | null => {
  if (!questionnaireHash) return null

  return null
}
